import api from '../../../services/api';

export interface OrderNotificationAssignmentDto {
  id: string;
  orderId: string;
  userId: string;
  userName: string;
  userEmail: string;
  assignedByName: string;
  source?: 'MANUAL' | 'ACCOUNT_MANAGER';
  createdAt: string;
}

export async function fetchOrderNotificationAssignments(orderId: string): Promise<OrderNotificationAssignmentDto[]> {
  const response = await api.get(`/notifications/orders/${orderId}/assignments`);
  return response.data;
}

export async function assignOrderNotificationRecipient(orderId: string, userId: string): Promise<void> {
  await api.post(`/notifications/orders/${orderId}/assignments`, { userId });
}

export async function removeOrderNotificationRecipient(orderId: string, userId: string): Promise<void> {
  await api.delete(`/notifications/orders/${orderId}/assignments/${userId}`);
}
